// f24-api.js — amm-v3 (A7, ondata 34 — SETTIMA e ultima ondata del cantiere):
// parte PURA della vista "Pagamenti F24" (pagina 'f24' — la LISTA dei modelli
// F24/versamenti), testabile sotto node (contract test
// server/src/lib/amm-v3-f24.test.js).
//
// PRINCIPI (rito A1..A6/proc-v3, spike o27 §2.2/§2.3):
//  - TESTI VERBATIM dal v1 (admin-module.js, renderF24 r.6883-6985): il contract
//    test pinna OGNI stringa di F24_TEXTS sul sorgente v1 — il drift fa ROSSO.
//  - FORMULE del v1 replicate come funzioni pure (KPI versato/da-pagare, anni
//    disponibili, data breve, etichetta badge tipo): stessa semantica, stessi
//    quirk (saldo null ⇒ 0, mai NaN).
//  - DELEGHE alle primitive v1 (mai reimplementate): IL WIZARD AI di import
//    quietanze (AMM.openImportQuietanza — dove vivono TUTTE le invarianti di
//    import: riversaStepCorrente anti-perdita-dati, busy() anti-doppio-click,
//    guardClose, guardia _importata anti-doppia-registrazione, errore rumoroso),
//    editor testata "+ Nuovo"/modifica (AMM.editF24), ravvedimento
//    (AMM.openRavvedimento), dettaglio F24 (AMM.openF24), elimina
//    (AMM.delSafe + AMM.messaggioCollegamenti), badge stato (AMM.f24StatoBadge,
//    HTML iniettato), filtri (AMM.f24MatchesFiltro/f24MatchesAnnoMeseStato, che
//    usano this.fmtEur2: chiamati SEMPRE come AMM.<m>(...) così this=AMM),
//    fmtEur2, isAdmin, toast. admin-module.js resta OFF-LIMITS: zero byte cambiati.
//    Il wizard è troppo accoppiato (multi-file, multi-quietanza, DOM-reading di
//    riversaStepCorrente): resta V1 as-is — confine DICHIARATO come le rate in A5.
//  - ZERO bypass di render: i modali ricevono l'onSaved che GLI PASSA il v3
//    (refresh v3 via renderPage); openF24 si auto-gestisce (parità v1: la lista
//    non si auto-aggiorna dopo il dettaglio) ⇒ NIENTE interceptor (census a7-01).
//  - MAI 'nav:badge' o canali nuovi da client/src/amm-v3/** (asserito dai test).

import { apiPathFn } from './api.js';

export const F24_DELEGATED_METHODS = [
  'renderPage',              // il seam stesso (wrap) + refresh post-azione
  'renderF24',               // la vista v1 wrappata (drift guard: rename ⇒ rosso)
  'toast',                   // esito eliminazione/export (stesso canale del v1)
  'isAdmin',                 // bottone "elimina" solo admin (parità r.6910)
  'delSafe',                 // eliminazione con alert d'errore (primitiva v1 r.878)
  'messaggioCollegamenti',   // testo extra nel confirm di eliminazione (v1 r.926/6922)
  'fmtEur2',                 // formattazione € (unica fonte: v1)
  'f24StatoBadge',           // badge stato (HTML v1, iniettato verbatim)
  'f24MatchesFiltro',        // filtro testo (usa this.fmtEur2: chiamato come AMM.<m>)
  'f24MatchesAnnoMeseStato', // filtro anno/mese/stato
  'editF24',                 // modale "+ Nuovo"/modifica testata — resta v1
  'openRavvedimento',        // modale ravvedimento — resta v1
  'openImportQuietanza',     // IL WIZARD AI import quietanze — resta v1 (confine)
  'openF24',                 // modale dettaglio (click riga) — resta v1
];

export const F24_API_PATHS = [
  'f24.list',          // GET /f24
  'f24.remove',        // DELETE /f24/:id
  'f24.collegamenti',  // GET /f24/:id/collegamenti (confirm di eliminazione)
  'export.download',   // Esporta CSV
];

// ---- TESTI VERBATIM dal v1 (pinnati dal contract test sul sorgente) ----
export const F24_TEXTS = {
  title: 'Pagamenti F24',
  titleTooltip: "Tecnicamente 'F24 / Versamenti'",
  exportCsv: 'Esporta CSV',
  importQuietanza: 'Importa quietanza (AI)',
  ravvedimento: 'Ravvedimento',
  nuovoF24: '+ Nuovo F24',
  kpiRegistrati: 'F24 registrati',
  kpiVersato: 'Totale versato',
  kpiDaPagare: 'Da pagare (bozza/predisposto)',
  filterPlaceholder: 'Cerca per riferimento/periodo o importo…',
  tuttiGliAnni: 'Tutti gli anni',
  tuttiIMesi: 'Tutti i mesi',
  colData: 'Data',
  colRiferimento: 'Riferimento',
  colRighe: 'Righe',
  colDebito: 'A debito',
  colCrediti: 'Crediti',
  colSaldo: 'Saldo',
  colStato: 'Stato',
  elimina: 'elimina',
  emptyFiltro: 'Nessun risultato per il filtro.',
  emptyBase: 'Nessun F24. Registra il primo con "+ Nuovo F24".',
  confirmElimina: 'Eliminare questo F24? Le scadenze collegate verranno riaperte.',
  toastEliminato: 'F24 spostato nel cestino',
  senzaPdf: 'senza PDF',
  senzaPdfTitle: 'Quietanza senza PDF allegato',
  exportToastPre: "Esportato l'anno ",
  exportToastPost: ' — seleziona un anno nel filtro per esportarne un altro',
  exportFallito: 'Export fallito: ',
  dash: '—',
};

// etichette mese del select (v1 MESI_OPT r.6929: value numerico → nome esteso)
export const MESI_OPT = [
  ['1', 'Gennaio'], ['2', 'Febbraio'], ['3', 'Marzo'], ['4', 'Aprile'],
  ['5', 'Maggio'], ['6', 'Giugno'], ['7', 'Luglio'], ['8', 'Agosto'],
  ['9', 'Settembre'], ['10', 'Ottobre'], ['11', 'Novembre'], ['12', 'Dicembre'],
];

// stati dei chip filtro (v1 STATI_OPT r.6930) — label = il valore stesso (esc(s))
export const STATI_OPT = ['bozza', 'predisposto', 'pagato', 'quietanzato', 'annullato'];

// etichette badge "tipo" del modello (v1 r.6901, inline map): mostrato SOLO se
// tipo && tipo !== 'ordinario'. Fallback al valore grezzo (quirk v1: || f.tipo).
export const TIPO_LABELS = { ravvedimento: 'ravvedimento', avviso_bonario: 'avviso bonario', cartella: 'cartella', rateizzazione: 'rata' };
export function tipoBadgeLabel(tipo) {
  return TIPO_LABELS[tipo] || tipo;
}
// il badge tipo appare solo per un tipo valorizzato e diverso da 'ordinario' (v1 r.6901)
export function mostraTipoBadge(tipo) {
  return !!(tipo && tipo !== 'ordinario');
}

// data breve italiana (v1 dd() r.6888): 'gg/mm/aaaa' o '—'
export function formatData(s) {
  return s ? new Date(s + 'T00:00:00').toLocaleDateString('it-IT') : F24_TEXTS.dash;
}

// totale versato (v1 r.6889-6890): Σ saldo dei soli stati pagato|quietanzato;
// saldo mancante ⇒ 0 (Number(f.saldo)||0), mai NaN.
export function versatiTotale(list) {
  return (list || [])
    .filter((f) => f.stato === 'pagato' || f.stato === 'quietanzato')
    .reduce((t, f) => t + (Number(f.saldo) || 0), 0);
}

// conteggio "da pagare" (v1 r.6891): stato bozza|predisposto
export function countBozza(list) {
  return (list || []).filter((f) => f.stato === 'bozza' || f.stato === 'predisposto').length;
}

// anni distinti presenti nei dati (v1 r.6887): dai primi 4 char di data_versamento,
// ordinati decrescente; senza data ⇒ escluso.
export function anniDisponibili(list) {
  return Array.from(new Set((list || []).map((f) => (f.data_versamento ? f.data_versamento.slice(0, 4) : null)).filter(Boolean)))
    .sort().reverse();
}

// KPI del riquadro (v1 r.6892/6937): registrati, totale versato €, da pagare.
export function kpiDefs(list, fmtEur2) {
  return [
    { label: F24_TEXTS.kpiRegistrati, val: String((list || []).length) },
    { label: F24_TEXTS.kpiVersato, val: fmtEur2(versatiTotale(list)) },
    { label: F24_TEXTS.kpiDaPagare, val: String(countBozza(list)) },
  ];
}

// messaggio vuoto (v1 r.6912-6913): con dati presenti = filtro a 0; senza dati = base.
export function emptyMessage(list) {
  return (list && list.length) ? F24_TEXTS.emptyFiltro : F24_TEXTS.emptyBase;
}

// ---- LETTURA dati (v1 r.6885): la lista F24 (una sola fetch, filtri client-side) ----
export async function readF24(win) {
  const list = await apiPathFn(win, 'f24.list').call(null);
  return list || [];
}

// ---- FILTRI (DELEGATI: le primitive v1 usano this.fmtEur2 → chiamate come AMM.<m>) ----
export function matchesFiltro(win, f, q) {
  return win.AMM.f24MatchesFiltro(f, q);
}
export function matchesAnnoMeseStato(win, f, anno, mese, stato) {
  return win.AMM.f24MatchesAnnoMeseStato(f, anno, mese, stato);
}
// riga visibile = passa entrambi i filtri (v1 r.6965)
export function filtraF24(win, list, q, anno, mese, stato) {
  return (list || []).filter((f) => matchesFiltro(win, f, q) && matchesAnnoMeseStato(win, f, anno, mese, stato));
}

// ---- AZIONI e DELEGHE (stessi punti del v1) ----
// "+ Nuovo F24" (modale testata v1). Il v3 passa il PROPRIO onSaved (refresh v3).
export function apriNuovoF24(win, onSaved) { win.AMM.editF24({}, onSaved); }
// Ravvedimento (modale v1) con onSaved v3 (parità r.6948).
export function apriRavvedimento(win, onSaved) { win.AMM.openRavvedimento({}, onSaved); }
// IL WIZARD AI import quietanze (modale v1) con onSaved v3 (parità r.6949) — CONFINE.
export function apriImportQuietanza(win, onSaved) { win.AMM.openImportQuietanza(onSaved); }
// Dettaglio F24 (modale v1): si auto-gestisce il reload interno; nessun callback
// verso la lista (parità v1 r.6926 — la lista non si auto-aggiorna dopo il dettaglio).
export function apriDettaglio(win, id) { win.AMM.openF24(id); }
// testo extra nel confirm di eliminazione (scadenze/figli collegati) — v1 r.6922.
// non bloccante: se collegamenti fallisce, extra resta '' (come il catch v1).
export async function messaggioCollegamentiF24(win, id) {
  try {
    return win.AMM.messaggioCollegamenti('f24', await apiPathFn(win, 'f24.collegamenti').call(null, id));
  } catch (e) {
    return '';
  }
}
// Elimina (delSafe v1: alert d'errore se fallisce), poi onOk (toast + refresh v3).
export function eliminaF24(win, id, onOk) {
  return win.AMM.delSafe(apiPathFn(win, 'f24.remove').call(null, id), onOk);
}
// Esporta CSV (v1 r.6953-6962): vista 'f24', anno dato (annoSel || anno corrente).
export function esportaCsv(win, anno) {
  return apiPathFn(win, 'export.download').call(null, 'f24', anno);
}
